import {createAction, createAsyncAction} from 'typesafe-actions';
import * as payloads from './payloads';
import {UpdateCallRecordingSegment} from './payloads';
import {FormatType, RecordingsPlayingState, TranscriptionData} from '../../reducers/calls/reducer';
import {APIErrorInterface} from '../../types';
import {ExtensionType} from '../../types/Extension';

export const getExtensionCallHistory = createAsyncAction(
    'GET_EXTENSION_CALL_HISTORY',
    'GET_EXTENSION_CALL_HISTORY_SUCCESS',
    'GET_EXTENSION_CALL_HISTORY_FAILED',
)<
    payloads.GetExtensionCallHistoryRequestPayload,
    payloads.GetCallHistoryResponsePayload,
    undefined
>();

export const getExtensionCallHistoryFile = createAsyncAction(
    'GET_EXTENSION_CALL_HISTORY_FILE',
    'GET_EXTENSION_CALL_HISTORY_FILE_SUCCESS',
    'GET_EXTENSION_CALL_HISTORY_FILE_FAILED',
)<payloads.GetExtensionCallHistoryFileRequestPayload, undefined, undefined>();

export const setCustomerCurrencyForCallHistory = createAction(
    'SET_CUSTOMER_CURRENCY_FOR_CALL_HISTORY',
)<payloads.SetCustomerCurrencyForCallHistoryPayload>();

export const getCallHistory = createAsyncAction(
    'GET_CALL_HISTORY',
    'GET_CALL_HISTORY_SUCCESS',
    'GET_CALL_HISTORY_FAILED',
)<
    payloads.GetCallHistoryRequestPayload,
    payloads.GetCallHistoryResponsePayload,
    undefined
>();

export const removeCallRecordings = createAsyncAction(
    'REMOVE_CALL_RECORDING',
    'REMOVE_CALL_RECORDING_SUCCESS',
    'REMOVE_CALL_RECORDING_FAILED',
)<payloads.RemoveCallRecoringsRequestPayload, undefined, undefined>();

export const getCallHistoryBasicData = createAsyncAction(
    'GET_CALL_HISTORY_BASIC_DATA',
    'GET_CALL_HISTORY_BASIC_DATA_SUCCESS',
    'GET_CALL_HISTORY_BASIC_DATA_FAILED',
)<payloads.GetCallHistoryBasicData, payloads.GetCallHistoryBasicDataResponsePayload, undefined>();

export const getSupervisorHeaderData = createAsyncAction(
    'GET_SUPERVISOR_HEADER_DATA',
    'GET_SUPERVISOR_HEADER_DATA_SUCCESS',
    'GET_SUPERVISOR_HEADER_DATA_FAILED',
)<undefined, undefined, undefined>();


export const getInitialCallHistoryBasicData = createAsyncAction(
    'GET_INITIAL_CALL_HISTORY_BASIC_DATA',
    'GET_INITIAL_CALL_HISTORY_BASIC_DATA_SUCCESS',
    'GET_INITIAL_CALL_HISTORY_BASIC_DATA_FAILED',
)<undefined, undefined, undefined>();

export const getCallHistoryFileAsBlob = createAsyncAction(
    'GET_CALL_HISTORY_FILE_AS_BLOB',
    'GET_CALL_HISTORY_FILE_AS_BLOB_SUCCESS',
    'GET_CALL_HISTORY_FILE_AS_BLOB_FAILED',
)<payloads.GetCallHistoryFileAsBlobRequestPayload, undefined, undefined>();

export const updateRecordingsPlayingState = createAction(
    'UPDATE_CALL_HISTORY_RECORDING_STATE',
)<RecordingsPlayingState>();
export const internalUpdateRecordingsPlayingState = createAction(
    'UPDATE_INTERNAL_CALL_HISTORY_RECORDING_STATE',
)<RecordingsPlayingState>();

export const getCallHistoryDataForStatistics = createAsyncAction(
    'GET_CALL_HISTORY_DATA_FOR_STATISTICS',
    'GET_CALL_HISTORY_DATA_FOR_STATISTICS_SUCCESS',
    'GET_CALL_HISTORY_DATA_FOR_STATISTICS_FAILED',
)<payloads.GetCallHistoryDataForStatisticsPayload, payloads.CallHistoryDataForStatisticsResponse, APIErrorInterface>();

export const getExtensionsListForCallsDoughnut = createAsyncAction(
    'GET_EXTENSIONS_FOR_CALLS_DOUGHNUT',
    'GET_EXTENSIONS_FOR_CALLS_DOUGHNUT_SUCCESS',
    'GET_EXTENSIONS_FOR_CALLS_DOUGHNUT_FAILED',
)<{skipService?:boolean, skipDid?:boolean, limit?:number}, ExtensionType[], APIErrorInterface>();

export const checkIfTranscriptionExist = createAsyncAction(
    'CHECK_IF_TRANSCRIPTION_EXIST_REQUEST',
    'CHECK_IF_TRANSCRIPTION_EXIST_SUCCESS',
    'CHECK_IF_TRANSCRIPTION_EXIST_FAILED',
)<{ callRecordingId: string, autoFetch?: boolean }, { transcriptionExist: boolean }, undefined>()

export const downloadTranscriptionFile = createAsyncAction(
    'DOWNLOAD_TRANSCRIPTION_FILE',
    'DOWNLOAD_TRANSCRIPTION_FILE_SUCCESS',
    'DOWNLOAD_TRANSCRIPTION_FILE_FAILED',
)<{ callRecordingId: string, type: FormatType }, undefined, undefined>()

export const fetchTranscription = createAsyncAction(
    'FETCH_TRANSCRIPTION',
    'FETCH_TRANSCRIPTION_SUCCESS',
    'FETCH_TRANSCRIPTION_FAILED',
)<{ callRecordingId: string, type?: FormatType }, TranscriptionData, undefined>()

export const deleteTranscription = createAsyncAction(
    'DELETE_TRANSCRIPTION',
    'DELETE_TRANSCRIPTION_SUCCESS',
    'DELETE_TRANSCRIPTION_FAILED',
)<{callRecordingId:string, callback?:()=>void}, undefined, undefined>()

export const updateCallRecordingSegment = createAsyncAction(
    'UPDATE_CALL_RECORDING_SEGMENT',
    'UPDATE_CALL_RECORDING_SEGMENT_SUCCESS',
    'UPDATE_CALL_RECORDING_SEGMENT_FAILED',
)<UpdateCallRecordingSegment, undefined, undefined>()